import SnowBallsAnimation from '../snowBallsAnimation/SnowBallsAnimation';
import '../CommonTheme.css';

const WinterTheme:React.FC = () => {
  let flakes = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,1,2,3,4,5,6,7,8,9,10,11,12];

  return (
    <>
    <SnowBallsAnimation/>
    <div className="snow_wrap">
        <div className="snow"></div>
        {
          flakes?.map((item,index)=>{
            return(
                <div className={`snowflex${item}`} key={index}></div>
            )})
        }
    </div>

    </>
  )
}

export default WinterTheme;